export const SELECTED_STATUSES_BY_PERIOD_ID = 'SELECTED_STATUSES_BY_PERIOD_ID';
export const CLEAR_STATUSES_BY_PERIOD_FILTERS = 'CLEAR_STATUSES_BY_PERIOD_FILTERS';
export const GET_STATUSES_BY_PERIOD_LIST = 'GET_STATUSES_BY_PERIOD_LIST';
export const GET_STATUSES_BY_PERIOD_PAGINATION = 'GET_STATUSES_BY_PERIOD_PAGINATION';
export const SET_CURRENT_STATUSES_BY_PERIOD_PAGE = 'SET_CURRENT_STATUSES_BY_PERIOD_PAGE';
export const SET_CURRENT_STATUSES_BY_PERIOD_SIZE = 'SET_CURRENT_STATUSES_BY_PERIOD_SIZE';
export const GET_STATUS_BY_PERIOD = 'GET_STATUS_BY_PERIOD';
export const SET_STATUSES_BY_PERIOD_LOADING = 'SET_STATUSES_BY_PERIOD_LOADING';
export const HIDE_LOADER = 'HIDE_LOADER';
export const INITIAL_STATUSES_BY_PERIOD_DATA = 'INITIAL_STATUSES_BY_PERIOD_DATA';
export const SHOW_EXPORT_STATUSES_BY_PERIOD_LOADING = 'SHOW_EXPORT_STATUSES_BY_PERIOD_LOADING';
export const SET_STATUSES_BY_PERIOD_FILTER = 'SET_STATUSES_BY_PERIOD_FILTER';
export const SET_USER_STATUS_SUCCESS = 'SET_USER_STATUS_SUCCESS';
export const GET_FILES_HISTORY = 'GET_FILES_HISTORY';
export const UPDATE_FILES_HISTORY = 'UPDATE_FILES_HISTORY';
export const SET_FILES_HISTORY_LOADER = 'SET_FILES_HISTORY_LOADER';
export const GET_FILES_PAGINATION = 'GET_FILES_PAGINATION';
export const SET_CURRENT_FILES_PAGE = 'SET_CURRENT_FILES_PAGE';
export const SET_CURRENT_FILES_SIZE = 'SET_CURRENT_FILES_SIZE';
